export const BACKGROUND_COLOR = '#e9edec'
export const GRID_LINE_COLOR = '#d9dfdb'
export const COLOR1 = ['#c5ae31', '#5fed83', '#bfbfbf', '#12bf3e', '#ae85ff', '#ffffff'] as const

export const COLOR2 = ['#f73679', '#ae85ff', '#ffe2f3', '#ffaba8', '#bba00b', '#E96E12', '#ffffff'] as const

export const COLOR3 = ['#178ffb', '#ffe2f3', '#BBA00A', '#AE85FF', '#180E27', '#AE85FF', '#ffffff'] as const

export function getColors(sectionId?: string) {
  switch (sectionId) {
    case 'foundations':
      return COLOR1
    case 'agents':
      return COLOR2
    case 'security':
      return COLOR3
    default:
      return COLOR1
  }
}
